import { Component, OnInit, QueryList, Renderer2, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { TiposEventosEnum } from '@appNeo/core/helpers/enums/tiposEventosEnum';
import { IPaquete } from '@appNeo/core/interfaces/IPaquete';
import { ITipoEvento } from '@appNeo/core/interfaces/ITipoEvento';
import { CalendarioOcioService } from '@appNeo/core/services/calendario-ocio/calendario-ocio.service';
import { PaquetesService } from '@appNeo/core/services/paquetes/paquetes.service';
import { ReservaService } from '@appNeo/core/services/reserva/reserva.service';
import { AuthService } from '@appNeo/neoCore/services/auth/auth.service';
import { FormularioComponent } from '@appNeo/neoShared/components/formulario/formulario.component';
import { NotificacionComponent } from '@appNeo/neoShared/components/notificacion/notificacion.component';
import { IconEnum } from '@appNeo/neoShared/helpers/enums/Icon.enum';
import { NotificacionEnum } from '@appNeo/neoShared/helpers/enums/Notificacion.enum';
import { ClasesPerfilAnchoEnum } from '@appNeo/neoShared/helpers/enums/perfil-propiedad-tag.enum';
import { ClasesCampoLayoutCamposPorcentajeFormularioEnum, ClasesFormularioAnchoEnum, IFormInput } from '@appNeo/neoShared/helpers/interfaces/IForm-input';
import { AuxiliarService } from '@appNeo/neoShared/services/auxiliar/auxiliar.service';
import { FormularioService } from '@appNeo/neoShared/services/formulario/formulario.service';
import { environment } from '@environments/environment';
import { FormularioWizardCumpleanosComponent } from './components/formulario-wizard-cumpleanos/formulario-wizard-cumpleanos.component';
import { FORMINPUT_EXTRAS_OPCIONALES, FORMINPUT_RESERVAR_PASO1, FormulariosReservaEnum } from './reservar-data';

import { HelpersService } from '@appNeo/neoCore/services/helpers/helpers.service';
import { EdicionSeccionesService } from '@appNeo/neoShared/modules/edicion-secciones/edicion-secciones.service';
import { ConfigTituloPaginasService } from '@appNeo/core/services/config-titulo-paginas.service';
import { filter, Subject, take, takeUntil } from 'rxjs';
import { IExtra } from '@appNeo/core/interfaces/IExtra';
import { TiposAsignacionPaqueteXExtraEnum } from '@appNeo/core/services/extras/extras.service';
import { FormTagEnum } from '@appNeo/neoShared/helpers/enums/FormTag.enum';
import { TiposPrecioExtra } from '@appNeo/core/global';

@Component({
  selector: 'neo-reservar',
  templateUrl: './reservar.component.html',
  styleUrls: ['./reservar.component.scss'],
  providers: [FormularioService],
  encapsulation: ViewEncapsulation.None
})
export class ReservarComponent implements OnInit {
  accesoAltaReservasPublico = environment.proximamente_reservas;
  paso = 1;
  procesando: boolean = false;
  formularioAncho: ClasesFormularioAnchoEnum.formularioAnchoMedio;
  /***************************************************************** */
  // configuracion datos
  /***************************************************************** */
  @ViewChild('notificacion') notificacion: NotificacionComponent;
  @ViewChild('notificacion_formularioExtrasOpcionalMultiple') notificacion_formularioExtrasOpcionalMultiple: NotificacionComponent;

  @ViewChild('formularioBusqueda') formularioBusqueda: FormularioComponent;
  formInputPaso1: IFormInput[] = FORMINPUT_RESERVAR_PASO1;
  tiposEvento: ITipoEvento[] = [];
  paquetes: IPaquete[] = [];
  tiposEventosEnum = TiposEventosEnum;

  bgrPortrait;
  bgrLandscape;
  idPaqueteRedireccion = '';
  /***************************************************************** */
  // formulario pasos reserva
  /***************************************************************** */
  @ViewChild('formularioReservaWizard') formularioReservaWizard: FormularioWizardCumpleanosComponent;

  /** extras
   *
   */
  @ViewChildren(NotificacionComponent) listadoNotificaciones: QueryList<NotificacionComponent>;

  @ViewChild('formularioExtrasOpcionalUnica') formularioExtrasOpcionalUnica: FormularioComponent;
  @ViewChild('formularioExtrasOpcionalMultiple') formularioExtrasOpcionalMultiple: FormularioComponent;
  @ViewChild('formularioExtras') formularioExtras: FormularioComponent;

  formInputExtras: IFormInput[] = []; // checbox para todos los extras a mayores ques e pueden incorporar al paquete bajo coste.
  // Segun paquete.numeroExtrasOpcionales
  formInputExtrasOpcionalUnica: IFormInput[] = FORMINPUT_EXTRAS_OPCIONALES; // radio button única opción.
  formInputExtrasOpcionalMultiple: IFormInput[] = []; // checkbox seleccion exact de numeroExtrasOpcionales

  // extras extender paquete seleccionado
  extrasPaquetes: IExtra[] = [];
  extrasNo_inluidoPaquete: IExtra[] = [];
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  numeroExtrasOpcionales: number;

  // tiposMenu: ITipoMenu[] = [];
  constructor(
    private renderer: Renderer2,
    private route: ActivatedRoute,
    private router: Router,
    private auxiliarService: AuxiliarService,
    public paquetesService: PaquetesService,
    public reservaService: ReservaService,
    public calendarioOcioService: CalendarioOcioService,
    private authService: AuthService,
    private helpersService: HelpersService,
    private edicionSeccionesService: EdicionSeccionesService,
    private configTitulo: ConfigTituloPaginasService,
    private formularioService: FormularioService
  ) {

    // if (environment.proximamente_reservas) {
    //   // redireccion a inicio con apertura de dialogo
    //   this.router.navigate([environment.pagina_aterrizaje_front], { state: { proximamente_dlg: true } })
    // }

    this.renderer.removeClass(document.body, 'main');
    this.renderer.addClass(document.body, 'mainFront');


    this.route.data.subscribe(
      response => {
        this.accesoAltaReservasPublico = (this.auxiliarService.getBoolean(response?.preferencias?.clave_matrix_acceso_alta_reservas_publico?.valor)) ? this.auxiliarService.getBoolean(response?.preferencias?.clave_matrix_acceso_alta_reservas_publico?.valor) : environment.proximamente_reservas;
        if (!this.accesoAltaReservasPublico) {
          this.router.navigate([environment.pagina_aterrizaje_front], { state: { proximamente_dlg: true } });
        }
        this.tiposEvento = (response?.tiposEvento) ? response.tiposEvento : [];
        this.paquetes = (response?.paquetes?.listadoEntidad)
          ? response?.paquetes?.listadoEntidad.filter(item => item.activo)
          : [];

        this.extrasPaquetes = [];

        this.route.paramMap.subscribe((paramMap) => {
          if (paramMap.has('idPaquete') && paramMap.get('idPaquete')) {
            let idPaqueteRedireccion = paramMap.get('idPaquete');
            this.idPaqueteRedireccion = (this.paquetes.findIndex(item => item.id === idPaqueteRedireccion) >= 0) ? idPaqueteRedireccion : '';
          }
        });
        this.cargarDatos();
      }
    );


  }

  ngOnInit(): void {
    this.configTitulo.establecerTitulo('Reservar');
    this.configTitulo.establecerMeta('Reservar');
    if (this.helpersService.hayModulo('edicion')) {
      this.edicionSeccionesService.getContenidoBloquesSubseccion('inicio-hero').subscribe(data => {
        data.elementos.forEach((elemento, index) => {
          let indice = (data.multiple) ? index : -1;
          this.bgrPortrait = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hero-img-portrait', indice);
          this.bgrLandscape = this.edicionSeccionesService.getCamposEdicionItem(elemento, 'hero-img-landscape', indice);
        });
      });
    }

    if (this.valoresInicialesBusqueda()?.idPaquete && this.valoresInicialesBusqueda()?.idPaquete !== '') {
      this.cargarExtrasPaquete(this.valoresInicialesBusqueda().idPaquete);
    }

    if (!this.valoresInicialesBusqueda()?.idTipoEvento) {
      this.reservaService.idTipoEvento = TiposEventosEnum.Cumpleanos;
      this.establecerCamposTipoEvento(TiposEventosEnum.Cumpleanos);
    }
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    // if (this.reservaService.esPagoCorrecto()) {
      this.eliminarFiltrosConsultaDisponibilidada();
      this.reservaService.eliminarReservaStorage();
    setTimeout(() => {
      this.calendarioOcioService.eliminarFiltros();
      this.paquetesService.entidad = undefined;
    });

    // }
  }

  ngAferViewInit(): void {

  }

  cargarDatos(identificadorFormulario = '') {
    // datos paso 1
    this.auxiliarService.busquedaPropiedad(this.formInputPaso1, 'formControlName', 'idTipoEvento').datos = this.tiposEvento;
    this.auxiliarService.busquedaPropiedad(this.formInputPaso1, 'formControlName', 'idPaquete').datos = this.paquetes;
    this.paquetesService.paquete$.subscribe(paquete => {
      console.log('CAMBIA EL PAQUETE ', paquete);
      if (paquete && paquete?.id) {
        // console.log('CAMBIA EL PAQUETE cargar extras peticion', paquete);
        // this.formularioBusqueda?.formValidators.get('idExtras').setValue('');
        this.notificacion.eliminarNotificaciones();
        this.cargarExtrasPaquete(paquete.id);
      } else {
        this.eliminarSeccionExtras();
      }
    });


  }

  eliminarSeccionExtras() {
    if (this.formInputExtrasOpcionalUnica) {
      this.auxiliarService.busquedaPropiedad(this.formInputExtrasOpcionalUnica, 'formControlName', 'extraOpcional').datos = [];
      setTimeout(() => {
        this.extrasPaquetes = [];
        this.formularioService.inputs = [];
      })
    }
    if (this.formInputExtrasOpcionalMultiple) {
      console.warn('Elminar formulario selecciona multiple formInputExtrasOpcionalMultiple');
      // this.auxiliarService.busquedaPropiedad(this.formInputExtrasOpcionalMultiple, 'formControlName', 'extraOpcional').datos = [];
      // setTimeout(() => {
      //   this.extrasPaquetes = [];
      //   this.formularioService.inputs = [];
      // })
    }
  }

  cargarExtrasPaquete(idPaquete) {
    if (idPaquete) {
      this.paquetesService.getExtrasAsociados(idPaquete).subscribe((datos: IExtra[]) => {
        if (datos && datos?.length > 0) {

          let extrasNo_inluidoPaquete = datos.filter(item => item['extra'].activo && item.idTipoAsignacionPaqueteXExtra !== TiposAsignacionPaqueteXExtraEnum.IncluidoPaquete);
          this.extrasNo_inluidoPaquete = extrasNo_inluidoPaquete;
          // console.log('CARGAR EXTRAS ASOCIADOS AL PAQUETE ACTIVOS no CORE', extrasNo_inluidoPaquete);
          if (extrasNo_inluidoPaquete.length > 0) {
            this.mapearFormularioExtras(extrasNo_inluidoPaquete);
            this.mapearFormularioExtrasOpcionales(extrasNo_inluidoPaquete);
          } else {
            this.extrasPaquetes = [];
          }
        } else {
          this.extrasPaquetes = [];
          // TODO ocultar
        }
      })
    }
  }

  // ocultarComboExtras() {
  //   this.auxiliarService.busquedaPropiedad(this.formInputPaso1, 'formControlName', 'idExtras').oculto = true;
  //   let propiedadExtras = this.auxiliarService.busquedaPropiedad(this.formInputPaso1, 'formControlName', 'idExtras');
  //   propiedadExtras.datos = [];
  // }

  onCambioFormulario(datosCambio, tagFormulario, data?: any) {
    this.procesando = false;
    if (this.notificacion_formularioExtrasOpcionalMultiple) {
      this.notificacion_formularioExtrasOpcionalMultiple.eliminarNotificaciones();
    }
    switch (tagFormulario) {
      case FormulariosReservaEnum.FR_PASO1:
        let primerCambio = datosCambio.campos.length == 0 && datosCambio.event.idPaquete != this.paquetesService.paquete$.value?.id;
        let cambioPaquete = datosCambio.campos.includes('idPaquete') && datosCambio.event.idPaquete != this.paquetesService.paquete$.value?.id;
        if (primerCambio || cambioPaquete) {
          this.paquetesService.entidad = this.paquetes.find(item => item.id == datosCambio.event.idPaquete)
        }

        if (!datosCambio.campos.includes('idExtras') && datosCambio.campos.includes('idTipoEvento') || !datosCambio.campos.includes('idExtras') && datosCambio.event.idTipoEvento != '') {
          this.reservaService.idTipoEvento = datosCambio.event.idTipoEvento;
          this.establecerCamposTipoEvento(datosCambio.event.idTipoEvento);
        }
        break;
      case FormulariosReservaEnum.FR_PASO2:
        break;
      case FormulariosReservaEnum.FR_PASO1_EXTRAS_OPCIONES_MULTIPLE: {
        let numeroExtrasOpcionalesSeleccionados = Object.keys(datosCambio.event).filter(key => datosCambio.event[key] === true);
        let numeroExtrasOpcionalesNoSeleccionados = Object.keys(datosCambio.event).filter(key => datosCambio.event[key] !== true);
        let numeroExtrasOpcionales = +data.numeroExtrasOpcionales;
        if (numeroExtrasOpcionalesSeleccionados.length > numeroExtrasOpcionales) {
          this.procesando = true;
          this.notificacion_formularioExtrasOpcionalMultiple.crearNotificacion(
            NotificacionEnum.Error,
            'Alcanzado el máximo permitido',
            `Has alcanzado el máximo permitido (${numeroExtrasOpcionales} actividades opcionales a seleccionar)`,
            true,
            IconEnum.Error
          );
        }
      }
      default:
        // throw new Error(`[ERROR RESERVAR] onCambioFormulario no detectado el formulario ${tagFormulario}`);
        break;

    }
  }

  // extras
  existenExtrasOpcionales() {
    let extrasOpcionales = this.extrasNo_inluidoPaquete
      ?.filter(item => item['extra'].activo && item.idTipoAsignacionPaqueteXExtra == TiposAsignacionPaqueteXExtraEnum.IncluidoOpcional)
    return extrasOpcionales.length > 0;
    // return this.auxiliarService.busquedaPropiedad(this.formInputExtrasOpcionalUnica, 'formControlName', 'extraOpcional')?.datos.length > 0;
    // return formInputExtrasOpcionalUnica[0].datos.length > 0
  }
  extraOpcionalDefecto() {
    let extraOpcional = {};
    if (this.existenExtrasOpcionales()) {
      extraOpcional = { extraOpcional: this.auxiliarService.busquedaPropiedad(this.formInputExtrasOpcionalUnica, 'formControlName', 'extraOpcional')?.datos[0]?.id };
    }
    return extraOpcional;
  }
  existenExtras() {
    return this.extrasPaquetes && this.extrasPaquetes.length > 0;
  }
  mapearFormularioExtrasOpcionales(extras) {
    this.paquetesService.paquete$.pipe(
      take(1),
      takeUntil(this._unsubscribeAll),
    )
      .subscribe((paquete) => {
        this.numeroExtrasOpcionales = paquete?.numeroExtrasOpcionales;
        if (paquete?.numeroExtrasOpcionales) {
          // opcion numeroExtrasOpcionales, 1 radiobutton, >1 checkbox obligatorios
          if (paquete?.numeroExtrasOpcionales == 1) {
            let propiedad = this.auxiliarService.busquedaPropiedad(this.formInputExtrasOpcionalUnica, 'formControlName', 'extraOpcional');
            if (propiedad) {
              let extrasOpcionales = extras
                ?.filter(item => item['extra'].activo && item.idTipoAsignacionPaqueteXExtra == TiposAsignacionPaqueteXExtraEnum.IncluidoOpcional)
                .map(item => ({
                  ...item, // Mantiene los datos originales
                  nombre: item.extra.nombrePublico // Agrega 'nombre' en el primer nivel
                })
                );

              propiedad.datos = (extrasOpcionales) ? extrasOpcionales : [];
            // console.log(' extrasOpcionales ', extrasOpcionales, propiedad);
            if (this.formularioExtrasOpcionalUnica && this.formularioExtrasOpcionalUnica?.formValidators) {
              this.formularioExtrasOpcionalUnica.formValidators.reset(this.extraOpcionalDefecto());
            }
          }
        }

        if (paquete?.numeroExtrasOpcionales > 1) {
          this.formInputExtrasOpcionalMultiple = [];
          extras
            ?.filter(item => item['extra'].activo && item.idTipoAsignacionPaqueteXExtra == TiposAsignacionPaqueteXExtraEnum.IncluidoOpcional)
            .map(item => ({
              ...item, // Mantiene los datos originales
              nombre: item.extra.nombrePublico // Agrega 'nombre' en el primer nivel
            })
            ).forEach((extra, index) => {
              // console.log('extra ', extra);
              this.formInputExtrasOpcionalMultiple.push({
                tag: FormTagEnum.checkbox,
                label: `${extra['extra'].nombrePublico}`,
                type: '',
                formControlName: extra['extra'].id,
                color: 'primary',
                obligatorio: false,
                disabled: false,
                datos: [],
                validadores: [],
                clasePersonalizadaLayoutCamposPorcentaje: [ClasesCampoLayoutCamposPorcentajeFormularioEnum.campoPorcent6x],
              });
            });
        }
      }
    });
  }

  mapearFormularioExtras(extras) {
    this.extrasPaquetes = extras?.filter(item => item['extra'].activo && item.idTipoAsignacionPaqueteXExtra == TiposAsignacionPaqueteXExtraEnum.Extra);
    this.formInputExtras = [];
    this.extrasPaquetes.forEach((extra, index) => {
      console.log('extra -----> ', extra);
      this.formInputExtras.push({
        tag: FormTagEnum.checkbox,
        label: `${extra['extra'].nombrePublico} (${extra['extra'].precio}€${extra['extra']?.tipoPrecioExtra?.id === TiposPrecioExtra.Unitario ? "/unidad" : ""})`,
        type: '',
        formControlName: extra['extra'].id,
        color: 'primary',
        obligatorio: false,
        disabled: false,
        datos: [],
        validadores: [],
        clasePersonalizadaLayoutCamposPorcentaje: [ClasesCampoLayoutCamposPorcentajeFormularioEnum.campoPorcent6x],
      });
    });
    console.log('Extras mapeados', this.formInputExtras, this.formularioService.inputs);
    if (this.formInputExtras && this.formInputExtras.length) {
      this.formularioService.inputs = this.formInputExtras;
    } else {
      this.formularioService.inputs = [];
    }
  }




  establecerCamposTipoEvento(idTipoEvento) {
    // let campoCondicionantes = ['idPaquete', 'idExtras'];
    let campoCondicionantes = ['idPaquete'];
    let formulario = this.formularioBusqueda;
    if (idTipoEvento == TiposEventosEnum.Cumpleanos) {
      campoCondicionantes.forEach(key => this.auxiliarService.busquedaPropiedad(this.formInputPaso1, 'formControlName', key).oculto = false);
      setTimeout(() => {
        if (formulario && formulario.formValidators) {
          campoCondicionantes.forEach(campo => {
            formulario?.formValidators?.get(campo).enable()
          });
        }
      })

    } else {
      campoCondicionantes.forEach(key => this.auxiliarService.busquedaPropiedad(this.formInputPaso1, 'formControlName', key).oculto = true);
      setTimeout(() => {
        if (formulario && formulario.formValidators) {

          campoCondicionantes.forEach(campo => {
            formulario?.formValidators?.get(campo).disable()
          });
        }
      })
    }
  }

  onSalir() {
    this.authService.logoutFrontAnonimo();
    this.eliminarFiltrosConsultaDisponibilidada();
    this.reservaService.eliminarReservaStorage();
    this.router.navigate(['/']);
  }

  // controles formulario busqueda
  onContinuar() {
    console.log('Continuar....');
    this.notificacion.eliminarNotificaciones();
    // this.procesando = true;
    this.formularioBusqueda.formValueReset = true;
    let objeto = (this.formularioBusqueda) ? this.formularioBusqueda.validaCampos(false) : undefined;

    if ((objeto && objeto.formulario.invalid)) {
      this.formularioBusqueda.formValueReset = true;
      this.procesando = false;
      this.notificacion.eliminarNotificaciones();
      this.notificacion.crearNotificacion(NotificacionEnum.Error, 'Error!', 'Rellene los campos obligatorios', true, IconEnum.Error);
      return;
    }

    let valores_fEO = {};

    // en caso de existir extras opcionales selecciona uno
    if (this.existenExtrasOpcionales()) {
      if ( this.formularioExtrasOpcionalUnica ) {

        let objeto_EO = (this.formularioExtrasOpcionalUnica) ? this.formularioExtrasOpcionalUnica.validaCampos(false) : undefined;
        if ((objeto_EO && objeto_EO.formulario.invalid)) {
          this.formularioExtrasOpcionalUnica.formValueReset = true;
          this.procesando = false;
          this.notificacion.eliminarNotificaciones();
          this.notificacion.crearNotificacion(NotificacionEnum.Error, 'Error!', 'Seleccione una actividad opcional', true, IconEnum.Error);
          return;
        }
        valores_fEO = (objeto_EO && objeto_EO.formulario.valid) ? objeto_EO.valores : {};
      }
      if ( this.formularioExtrasOpcionalMultiple ) {

        let objeto_EOM = (this.formularioExtrasOpcionalMultiple) ? this.formularioExtrasOpcionalMultiple.validaCampos(false) : undefined;
        let valoresExtras = objeto_EOM.formulario.value;
        let cantidadExtras = Object.values(valoresExtras).filter(valor => valor === true).length;

        if ((objeto_EOM && (objeto_EOM.formulario.invalid || cantidadExtras != this.numeroExtrasOpcionales))) {
          this.formularioExtrasOpcionalMultiple.formValueReset = true;
          this.procesando = false;
          this.notificacion.eliminarNotificaciones();
          this.notificacion.crearNotificacion(NotificacionEnum.Error, 'Error!', 'Seleccione '+ this.numeroExtrasOpcionales +' actividades opcionales', true, IconEnum.Error);
          return;
       }
        valores_fEO = (objeto_EOM && objeto_EOM.formulario.valid) ? {extraOpcional: Object.keys(objeto_EOM.valores).map(Number) }  : {};
      }
    }

    let objeto_E = (this.formularioExtras) ? this.formularioExtras.validaCampos(false) : undefined;
    if ((objeto_E && objeto_E.formulario.invalid)) {
      this.formularioExtras.formValueReset = true;
      this.procesando = false;
      this.notificacion.eliminarNotificaciones();
      this.notificacion.crearNotificacion(NotificacionEnum.Error, 'Error!', 'Seleccione un extra', true, IconEnum.Error);
      return;
    }
    let valores_fE = (objeto_E && objeto_E.formulario.valid) ? objeto_E.valores : {};

    let extras = Object.keys(valores_fE).length ? Object.keys(valores_fE) : [];
    if (valores_fEO && valores_fEO['extraOpcional']) { extras.push(valores_fEO['extraOpcional']) }
    let idExtras = (extras.length > 0) ? extras.toString() : '';
    // console.log('idExtras', valores_fE, valores_fEO, idExtras);

    if ([TiposEventosEnum.Comuniones, TiposEventosEnum.Otros].includes(objeto.valores.idTipoEvento)) {
      // formulario para otro tipo evento no cumpleanos
      throw new Error(`[ERROR RESERVAR] onContinuar traza envio contacto otro evento no implementada`);
    }
    if ([TiposEventosEnum.Cumpleanos].includes(objeto.valores.idTipoEvento)) {
      console.log('ESTABLECER FILTROS CONSULTA DISPONIBILIDAD ', objeto.valores);
      this.establecerFiltrosConsultaDisponibilidada({ ...objeto.valores, idExtras });
      this.confirmarBusqueda(true);

      // formularo pasos continua
      // throw new Error(`[ERROR RESERVAR] onContinuar traza reserva cumpleanos no implementada`);
    }

  }

  onCancelar() {
    this.onSalir();
    // this.formularioBusqueda.formValidators.reset({ idPaquete: '', idTipoEvento: TiposEventosEnum.Cumpleanos });
    // this.calendarioOcioService.eliminarFiltros();
    // eliminacion busqueda
    // this.eliminarFiltrosConsultaDisponibilidada();
    // redireccion inicio
  }

  // controles formularios wizard configuracion reserva
  onAtras() {
    if (!this.reservaService.esPagoCorrecto()) {
      this.formularioReservaWizard.onAtras();
    }
    // this.confirmarBusqueda(false);
  }

  onContinuarConfiguracion() {
    this.formularioReservaWizard.onContinuar();
  }

  onReservar() {
    this.formularioReservaWizard.onReservar();
  }

  onPagar() {
    this.formularioReservaWizard.onPagar();
  }

  onVolverAIntentarlo() {
    if (this.reservaService.intentoPagoFallido$.value) {
      this.formularioReservaWizard.onAtras();
    }
  }

  onGestionarMiReserva() {
    this.calendarioOcioService.eliminarFiltros();
    this.paquetesService.entidad = undefined;
    this.authService.logoutFront();
    this.authService.logoutFrontAnonimo();
    this.router.navigate([environment.ruta_padre_areaCliente + '/informacion-reserva'])
  }


  get existeBusqueda(): boolean {
    return (this.obtenerFiltrosBusquedaActuales() != null && this.obtenerFiltrosBusquedaActuales()?.idPaquete != '' &&
      this.obtenerFiltrosBusquedaActuales()?.idTipoEvento != '' && this.obtenerBusquedaActiva());
  }
  obtenerFiltrosBusquedaActuales() {
    return this.calendarioOcioService.filtrosConsultaDisponibilidad$.value;
  }
  valoresInicialesBusqueda() {
    // formateo valores multiples
    if (this.idPaqueteRedireccion) {
      this.calendarioOcioService.filtrosConsultaDisponibilidad = { ...this.calendarioOcioService.filtrosConsultaDisponibilidad$.value, idPaquete: this.idPaqueteRedireccion, idTipoEvento: TiposEventosEnum.Cumpleanos }
    }
    let valores = this.obtenerFiltrosBusquedaActuales();
    // if (valores?.idExtras) {
    //   valores.idExtras = [];
    //   // delete valores.idExtras;
    // }
    return valores;
  }

  obtenerBusquedaActiva() {
    return this.calendarioOcioService.confirmarBusqueda$.value;
  }


  eliminarFiltrosConsultaDisponibilidada() {
    // console.log('eliminarFiltrosConsultaDisponibilidada');
    // this.establecerFiltrosConsultaDisponibilidada({});
    this.calendarioOcioService.eliminarFiltros();
    this.paquetesService.entidad = undefined;

  }
  establecerFiltrosConsultaDisponibilidada(filtros) {
    this.calendarioOcioService.filtrosConsultaDisponibilidad = filtros;

  }
  confirmarBusqueda(buscar) {
    this.calendarioOcioService.confirmarBusqueda = buscar;
    // if (!buscar) {
    //   this.auxiliarService.busquedaPropiedad(this.formInputPaso1, 'formControlName', 'idExtras').oculto = true;
    // }
    if (buscar) {
      this.reservaService.eliminarReservaStorage();
      setTimeout(() => {
        this.formularioReservaWizard.onIniciarConfiguracion();
      });
    }

  }

}
